export default __webpack_public_path__ + "static/app-store-9d04f3343fa3fdf8237f5868785fb839.svg";